export const RNECEventEnum = {
    ERROR: 'error',
    NO_HIT: 'noHit',
    OK: 'ok',
    ADVISER_FAIL: 'adviserFail',
    RNEC: 'rnec',
    RNEC_CAPTURE: 'rnecCapture',
    EXPDATE: 'expdatetries'
} as const;



// WEBPACK FOOTER //
// ./src/app/authentication-rnec/authentication-rnec.enum.ts